<template>
    <div id="technologies" class="technologies">
        <div class="legend">Technologies I work with</div>
        <div class="container">
            <div class="list-item">
                <div class="description" data-aos="fade-right" data-aos-duration="1200" data-aos-delay="100">
                    <ul>
                        <li>Languages</li>
                    </ul>
                </div>
                <div class="languages-container" data-aos="fade-right" data-aos-duration="1200" data-aos-delay="300">
                    <div class="image-wrapper java">
                        <v-img :src="require('@/assets/images/java.png')" />
                    </div>
                    <div class="image-wrapper c">
                        <v-img :src="require('@/assets/images/c.png')" />
                    </div>
                    <div class="image-wrapper javascript">
                        <v-img :src="require('@/assets/images/javascript.png')" />
                    </div>
                    <div class="image-wrapper html">
                        <v-img :src="require('@/assets/images/html.png')" />
                    </div>
                    <div class="image-wrapper css">
                        <v-img :src="require('@/assets/images/css.png')" />
                    </div>
                </div>
            </div>
            <div class="list-item">
                <div class="description" data-aos="fade-right" data-aos-duration="1200" data-aos-delay="400">
                    <ul>
                        <li>Frameworks</li>
                    </ul>
                </div>
                <div class="frameworks-container" data-aos="fade-right" data-aos-duration="1200" data-aos-delay="600">
                    <div class="image-wrapper spring">
                        <v-img :src="require('@/assets/images/spring.png')" />
                    </div>
                    <div class="image-wrapper vue">
                        <v-img :src="require('@/assets/images/vuejs.png')" />
                    </div>
                    <div class="image-wrapper">
                        <v-img :src="require('@/assets/images/vuetify.png')" />
                    </div>
                    <div class="image-wrapper bootstrap">
                        <v-img :src="require('@/assets/images/bootstrap.png')" />
                    </div>
                    <div class="image-wrapper">
                        <v-img :src="require('@/assets/images/react-admin.png')" />
                    </div>
                    <div class="image-wrapper mindar">
                        <v-img :src="require('@/assets/images/mindar.png')" />
                    </div>
                </div>
            </div>
            <div class="list-item">
                <div class="description" data-aos="fade-right" data-aos-duration="1200" data-aos-delay="800">
                    <ul>
                        <li>Engines and Infrastructure</li>
                    </ul>
                </div>
                <div class="infrastructure-container" data-aos="fade-right" data-aos-duration="1200" data-aos-delay="1000">
                    <div class="image-wrapper spark">
                        <v-img :src="require('@/assets/images/spark.png')" />
                    </div>
                    <div class="image-wrapper my-sql">
                        <v-img :src="require('@/assets/images/mySql.png')" />
                    </div>
                    <div class="image-wrapper">
                        <v-img :src="require('@/assets/images/mongoDb.png')" />
                    </div>
                    <div class="image-wrapper git">
                        <v-img :src="require('@/assets/images/git.png')" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Technologies'
    }
</script>
<style scoped>
.container {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding-left: 2%;
    padding-right: 2%;
}

.technologies {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f8fc;
    padding-top: 3%;
}

.languages-container,
.frameworks-container,
.infrastructure-container {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
}

.image-wrapper {
    max-width: 200px;
    margin: 1%;
    text-align: center;
    align-self: center;
    justify-self: center;
}

.javascript,
.c,
.vue,
.bootstrap,
.my-sql,
.mindar {
    max-width: 100px;
}

.spring,
.spark {
    max-width: 150px;
}

.css,
.html {
    max-width: 90px;
}

.git {
    max-width: 120px;
}

.list-item {
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.legend {
    font-family: "Poppins-Bold";
    font-size: 2em;
    margin-left: 2%;
}

.description {
    font-family: "Poppins";
    font-size: 1.3em;
    color: #7e7e7e;
    margin-bottom: 1rem;
}

@media screen and (max-width: 768px) {
    .technologies {
        padding-left: 0;
    }
}
</style>
